<template>
  <div>
    <slot></slot>
    <van-overlay :show="isLoading">
      <van-loading
        class="wrapper"
        color="#1989fa"
      />
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: "baseContainer",
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
.base-container{
  width: 100%;
  height: 100%;
  margin: 0 0;
  padding: 0 0;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>